import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed z-30 w-screen bg-dynamicHeader" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "container mx-auto flex h-20 max-w-7xl justify-between px-2" }
const _hoisted_4 = { class: "flex grow items-center justify-center md:flex-none" }
const _hoisted_5 = { class: "flex items-center xs:ml-1" }

import {
  computed,
  ref,
} from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import DesktopHeaderMenu from '@/components/Navbar/Logged/DesktopHeaderMenu.vue';
import LoggedLeftDropdown from '@/components/Navbar/Logged/LoggedLeftDropdown.vue';
import MemberMenu from '@/components/Navbar/Logged/MemberMenu.vue';
import NavLogo from '@/components/Navbar/NavLogo.vue';
import SearchCourse from '@/components/Navbar/SearchCourse.vue';
import {
  CONSTANTS,
} from '@/helpers';
import {
  useStore,
} from '@/store';
import type {
  INav,
} from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoggedHeader',
  setup(__props) {


const router = useRouter();
const route = useRoute();

const { features } = useStore.backend.clientCompany.subscriptionSettings;

const availableNavs = computed(() => {
  const navs: INav[] = [
    CONSTANTS.ROUTE.myEnrolledCourses,
    CONSTANTS.ROUTE.dynamicPages,
    CONSTANTS.ROUTE.myUpcomingCourses,
    CONSTANTS.ROUTE.myRunningCourses,
    CONSTANTS.ROUTE.freeCourses,
  ];

  if (useStore.app.breakpoint !== 'lg') {
    if (features.noticeBoard) {
      navs.push(CONSTANTS.ROUTE.news);
    }

    navs.push(...useStore.app.viewConfig.dynamicRoutes);
  }

  return navs;
});

const isHamburgerOpen = ref(false);
const isDynamicPageNonMobileOpen = ref(false);
const isDynamicPageMobileOpen = ref(false);

function onNavClick(nav: INav): void {
  const { path, alternateTitle } = nav;

  if (path.startsWith('http')) {
    window.open(path, '_blank');
    return;
  }

  if (alternateTitle === CONSTANTS.ROUTE.dynamicPages.alternateTitle) {
    isDynamicPageMobileOpen.value = !isDynamicPageMobileOpen.value;
    return;
  }

  isHamburgerOpen.value = false;
  isDynamicPageMobileOpen.value = false;

  if (route.path === path) {
    return;
  }

  router.push(path);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(LoggedLeftDropdown, {
          availableNavs: availableNavs.value,
          isHamburgerOpen: isHamburgerOpen.value,
          isDynamicPageMobileOpen: isDynamicPageMobileOpen.value,
          "onUpdate:dpMobileOpen": _cache[0] || (_cache[0] = ($event: any) => (isDynamicPageMobileOpen.value = $event)),
          "onUpdate:hamburgerOpen": _cache[1] || (_cache[1] = ($event: any) => (isHamburgerOpen.value = $event)),
          "onClick:nav": onNavClick
        }, null, 8, ["availableNavs", "isHamburgerOpen", "isDynamicPageMobileOpen"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(NavLogo)
        ]),
        _createVNode(DesktopHeaderMenu, {
          availableNavs: availableNavs.value,
          isDynamicPageNonMobileOpen: isDynamicPageNonMobileOpen.value,
          "onUpdate:dpNonMobileOpen": _cache[2] || (_cache[2] = ($event: any) => (isDynamicPageNonMobileOpen.value = $event)),
          "onClick:nav": onNavClick
        }, null, 8, ["availableNavs", "isDynamicPageNonMobileOpen"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SearchCourse),
          _createVNode(MemberMenu)
        ])
      ])
    ])
  ]))
}
}

})